import { useRoute } from 'shared/src/hooks/useRoute';

export type MyPageParamList = {
  AlarmSetting: {
    instanceId?: string;
  };
  Laboratory: {
    instanceId?: string;
  };
  MyPersonalization: {
    instanceId?: string;
    from?: string;
    initialTabIndex?: number;
    productCategorySno?: number;
  };
  PointOfContact: {
    instanceId?: string;
  };
};

export const useMyPageRoute = <Key extends keyof MyPageParamList>() =>
  useRoute<MyPageParamList, Key>();
